'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Helpers = require('common/Helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEmpty = require('lodash.isempty');
// const difference = require('lodash.difference');

var getChildHandles = function getChildHandles(productContainers) {
  var containers = Object.values(productContainers);
  var handles = containers.map(function (container) {
    return container._data.product.child_handles;
  }).filter(function (handle) {
    return handle;
  }).reduce(function (childHandles, handles) {
    return [].concat((0, _toConsumableArray3.default)(childHandles), (0, _toConsumableArray3.default)(handles));
  }, []);

  return (0, _Helpers.unique)(handles);
};

var getVariantIds = function getVariantIds(productContainers) {
  var containers = Object.values(productContainers);
  var variantIds = containers.filter(function (container) {
    return container._data.product.child_handles && !container._data.product.child_handles.length;
  }).map(function (container) {
    return container._data.product.variantIds;
  }).reduce(function (variantIds, ids) {
    return [].concat((0, _toConsumableArray3.default)(variantIds), (0, _toConsumableArray3.default)(ids));
  }, []);

  return (0, _Helpers.unique)(variantIds);
};

var getDyHandles = function getDyHandles(productContainers) {
  var containers = Object.values(productContainers);
  var handles = containers.filter(function (container) {
    return container._data.variant.length === 0;
  }).map(function (container) {
    return container.variantId;
  });

  return (0, _Helpers.unique)(handles);
};

// Ponyfill for IE11 not supporting Object.fromEntries
var fromEntries = function fromEntries(iterable) {
  return [].concat((0, _toConsumableArray3.default)(iterable)).reduce(function (obj, _ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    obj[key] = val;
    return obj;
  }, {});
};

// Ponyfill for Object.entries
var entries = function entries(obj) {
  var ownProps = Object.keys(obj);
  var i = ownProps.length;
  var resArray = new Array(i); // preallocate the Array

  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }

  return resArray;
};

var init = exports.init = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var productContainers, variantHandles, dummyProductHandle, resourceStrings, templateOptions, promises, parentChildMap, childParentMap, variantIdMap, variantMap;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            productContainers = State.get('product');

            if (!isEmpty(productContainers)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt('return');

          case 4:
            variantHandles = (0, _Helpers.unique)([].concat((0, _toConsumableArray3.default)(getChildHandles(productContainers)), (0, _toConsumableArray3.default)(getDyHandles(productContainers))));
            dummyProductHandle = Object.values(productContainers)[0]._data.product.handle;
            resourceStrings = Array(Math.ceil(variantHandles.length / 20)).fill().map(function (_, index) {
              var start = index * 20;
              var end = (index + 1) * 20;
              var handles = variantHandles.slice(start, end).join(',');

              return 'products/' + dummyProductHandle + '/' + handles;
            });
            templateOptions = { templateName: 'child-variant-ids', json: true };
            promises = resourceStrings.map(function (resource) {
              return (0, _Helpers.getAlternativeTemplate2)(Object.assign({}, templateOptions, { resource: resource })).then(function (res) {
                return fromEntries(entries(res).filter(function (_ref4) {
                  var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
                      key = _ref5[0],
                      value = _ref5[1];

                  return !!key && !!value;
                }));
              });
            });
            _context.next = 11;
            return Promise.all(promises).then(function (res) {
              return res.reduce(function (map, ids) {
                return Object.assign({}, map, ids);
              }, {});
            });

          case 11:
            parentChildMap = _context.sent;
            childParentMap = fromEntries(entries(parentChildMap).map(function (entry) {
              return entry.reverse();
            }));
            variantIdMap = getVariantIds(productContainers).reduce(function (variantIdMap, id) {
              return Object.assign({}, variantIdMap, (0, _defineProperty3.default)({}, id, id));
            }, {});
            variantMap = Object.assign({}, parentChildMap, childParentMap, variantIdMap);


            State.set(Object.assign({ change: 'update', container: 'variant' }, variantMap));
            _context.next = 21;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context['catch'](0);

            console.log(_context.t0);

          case 21:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 18]]);
  }));

  return function init() {
    return _ref3.apply(this, arguments);
  };
}();

exports.default = {
  init: init
};